export const GRANTED = 'GRANTED';
export const REJECTED = 'REJECTED';
